// extracted by mini-css-extract-plugin
module.exports = {"root":"Tags_root__FqGDQ","item":"Tags_item__Of0B4"};